import { Link } from 'react-router-dom';
import { siteInfo } from '@/mocks/siteInfo';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-background-200/70 border-t border-background-300/60">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="lg:col-span-1">
            <Link to="/" className="text-2xl font-semibold font-heading text-foreground-900 whitespace-nowrap">
              {siteInfo.name}
            </Link>
            <p className="mt-4 text-sm text-foreground-500 leading-relaxed">
              {siteInfo.tagline}
            </p>
            <div className="flex items-center gap-4 mt-5">
              <a href={siteInfo.socialLinks.weibo} target="_blank" rel="nofollow noopener" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-300 text-foreground-600 hover:bg-primary-500 hover:text-background-50 transition-colors" aria-label="微博">
                <i className="ri-weibo-line text-base"></i>
              </a>
              <a href={siteInfo.socialLinks.xiaohongshu} target="_blank" rel="nofollow noopener" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-300 text-foreground-600 hover:bg-primary-500 hover:text-background-50 transition-colors" aria-label="小红书">
                <i className="ri-red-packet-line text-base"></i>
              </a>
              <a href={siteInfo.socialLinks.douyin} target="_blank" rel="nofollow noopener" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-300 text-foreground-600 hover:bg-primary-500 hover:text-background-50 transition-colors" aria-label="抖音">
                <i className="ri-tiktok-line text-base"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-5 font-heading">攻略分类</h4>
            <ul className="space-y-3">
              {categories.map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-5 font-heading">推荐目的地</h4>
            <ul className="space-y-3">
              <li><Link to="/article/article-3" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap">巴厘岛蜜月</Link></li>
              <li><Link to="/article/article-1" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap">大理洱海</Link></li>
              <li><Link to="/article/article-5" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap">京都红叶</Link></li>
              <li><Link to="/article/article-9" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap">清迈慢生活</Link></li>
              <li><Link to="/article/article-7" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap">三亚度假</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-5 font-heading">关于我们</h4>
            <ul className="space-y-3">
              <li><Link to="/about" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap">品牌故事</Link></li>
              <li><a href={`mailto:${siteInfo.email}`} className="text-sm text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap">联系我们</a></li>
              <li><span className="text-sm text-foreground-400">{siteInfo.email}</span></li>
              <li><span className="text-sm text-foreground-400">{siteInfo.phone}</span></li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-background-300/60">
        <div className="max-w-7xl mx-auto px-4 md:px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-400">
            &copy; {new Date().getFullYear()} {siteInfo.name}. 让每一段爱情，都拥有属于自己的岛屿。
          </p>
          <div className="flex items-center gap-6">
            <span className="text-xs text-foreground-400">浙ICP备2024000000号</span>
          </div>
        </div>
      </div>
    </footer>
  );
}